import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_8.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/foster');
  const shareText = encodeURIComponent('Foster an environment where every employee feels valued, heard, and empowered to contribute!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Foster Environment — Outstanding Workplaces</title>
        <meta property="og:title" content="Foster Environment — Outstanding Workplaces" />
        <meta property="og:description" content="Foster an environment where every employee feels valued, heard, and empowered to contribute" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777979555/i_8_md5ond.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/foster" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Foster Environment — Outstanding Workplaces" />
        <meta name="twitter:description" content="Foster an environment where every employee feels valued, heard, and empowered to contribute" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777979555/i_8_md5ond.jpg" />
      </Helmet>

       <div className="sight_8_page_wrapper">
      <div className="sight_8_content_container">

        <div className="sight_8_section_one">

          {/* TITLE */}
          <h1 className="sight_8_page_title">
            Foster an environment where every employee feels valued, heard, and empowered to contribute
          </h1>

          {/* ROW */}
          <div className="sight_8_row">

            {/* LEFT SIDE */}
            <div className="sight_8_left">
              <div className="sight_8_image_wrapper">
                <img
                  src="/assets/i_8.jpg"
                  alt="Team meeting discussion"
                  className="sight_8_blog_image"
                />
              </div>

                {/* SHARE SECTION */}
                <div className="sight_8_share_section">
                  <span className="sight_8_share_text">Share :</span>
                  <div className="sight_8_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_8_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_8_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_8_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_8_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

              <p className="sight_8_intro_paragraph">
                An inclusive culture goes beyond diversity—it’s about creating an environment where every voice is heard, valued, and empowered. Thought leaders in modern workplaces understand that innovation and engagement flourish when employees feel respected and included. By embedding inclusivity into policies, communication, and leadership practices, organizations build stronger teams, enhance collaboration, and drive sustainable performance.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_8_right">
              <div className="sight_8_ad_card">
                <img src="/assets/bc_1.png" className="sight_8_ad_bg" />
                <div className="sight_8_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_8_ad_badge" />

                <div className="sight_8_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_8_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_8_section">


          <ul className="sight_8_intro_list">
  <li>
    In essence, inclusive culture isn’t just a moral imperative—it’s a strategic advantage that shapes the future of work and positions leaders as champions of meaningful, people-centric change.
  </li>
</ul>

          <div className="sight_8_topics">

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Why Inclusive Culture is the Backbone of Modern Workplaces</h2>
              <ul className="sight_8_topic_list">
                <li>Explore how diversity and inclusion drive engagement, innovation, and retention.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">From Policy to Practice: Building an Inclusive Workplace</h2>
              <ul className="sight_8_topic_list">
                <li>Step-by-step strategies to move beyond token initiatives into real cultural change.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Leadership’s Role in Shaping an Inclusive Culture</h2>
              <ul className="sight_8_topic_list">
                <li>Discuss how leaders can model inclusivity and influence organizational norms.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Measuring Inclusion: Metrics That Matter</h2>
              <ul className="sight_8_topic_list">
                <li>Identify KPIs and tools to track diversity, equity, and inclusion progress.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Inclusive Hiring: Strategies to Attract Diverse Talent</h2>
              <ul className="sight_8_topic_list">
                <li>Share actionable hiring practices that reduce bias and broaden the talent pool.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Employee Resource Groups (ERGs): Driving Engagement and Belonging</h2>
              <ul className="sight_8_topic_list">
                <li>Highlight how ERGs support underrepresented employees and foster community.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Inclusive Communication: Making Every Voice Heard</h2>
              <ul className="sight_8_topic_list">
                <li>Focus on transparency, accessibility, and feedback mechanisms that empower everyone.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Overcoming Unconscious Bias in the Workplace</h2>
              <ul className="sight_8_topic_list">
                <li>Insights, training approaches, and practical exercises to minimize bias at work.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Inclusive Culture and Innovation: Why Diversity Sparks Creativity</h2>
              <ul className="sight_8_topic_list">
                <li>Explain the link between diverse perspectives and better problem-solving.</li>
              </ul>
            </div>

            <div className="sight_8_topic_item">
              <h2 className="sight_8_topic_heading">Case Studies: Companies Winning at Inclusive Culture</h2>
              <ul className="sight_8_topic_list">
                <li>Showcase real-world examples of organizations successfully embedding inclusion.</li>
              </ul>
            </div>

          </div>
        </div>

       </div>
   </div>
    </>
  );
}

export default BlogPage;

